/*
  Tapping the gallery on mobile did not open the lightbox: ModalOpener binds to the
  small toggle button, whose ::after overlay can be covered by other positioned
  elements in the gallery. This delegated listener opens the modal from anywhere on
  the media item, in the capture phase so nothing can swallow it first. It no-ops if
  the modal is already open, so it never double-fires with ModalOpener.
*/
document.addEventListener(
  'click',
  (event) => {
    const opener = event.target.closest('modal-opener.product__modal-opener--image');
    if (!opener) return;
    const modal = document.querySelector(opener.getAttribute('data-modal'));
    if (!modal || modal.hasAttribute('open')) return;
    const button = opener.querySelector('.product__media-toggle');
    if (!button || getComputedStyle(button).display === 'none') return;
    // Only lightbox mode opens the modal. In "click and hover" the click belongs
    // to magnify.js, so this must not swallow it.
    if (!button.classList.contains('product__media-zoom-lightbox')) return;
    event.preventDefault();
    modal.show(button);
  },
  true
);

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.hydrateZoomImages();
        this.showActiveMedia();
      }

      // The modal sits at full viewport size behind visibility:hidden, so its images
      // would otherwise download on page load even with loading="lazy".
      hydrateZoomImages() {
        this.querySelectorAll('img[data-zoom-src]').forEach((img) => {
          img.srcset = img.dataset.zoomSrcset || '';
          img.src = img.dataset.zoomSrc;
          delete img.dataset.zoomSrc;
          delete img.dataset.zoomSrcset;
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
